<template>
    <div class="fw-yyfx">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <Cxdate @chaxun="chaxun"/>
        <div class="yyfx">
            <div class="yyfx-item1">
                <div>
                    <span style="font-size: 15px;padding: 8px">概览 <span style="font-size: 12px">收入=成交-分账-服务费</span></span>
                    <div class="yyfx-nr1">
                        <div class="nr-item1">
                            <span>成交额</span>
                            <span>{{gailan.payPrice}}</span>
                        </div>
                        <div class="nr-item1">
                            <span>分账</span>
                            <span>{{gailan.fzAmount}}</span>
                        </div>
                        <div class="nr-item1">
                            <span>服务费</span>
                            <span>{{gailan.fwFee}}</span>
                        </div>
                    </div>
                </div>
                <div class="yyfx-item-bt1">
                    <span>成交统计</span>
                </div>
                <div style="margin-left: 20%;border-bottom: #EEEEEE solid 1px;"></div>
                <div class="tj-nr">
                    <div class="tjnr-item1">
                        <span class="sp-bt">类型</span>
                        <span class="sp-val1">到店</span>
                        <span class="sp-val1">快递</span>
                        <span class="sp-val2">总计</span>
                    </div>
                    <div class="tjnr-item">
                        <span class="sp-bt">订单数量</span>
                        <span class="sp-val">{{cjMap.dd.num}}</span>
                        <span class="sp-val">{{cjMap.kd.num}}</span>
                        <span class="sp-val2">{{cjMap.zj.num}}</span>
                    </div>
                    <div class="tjnr-item">
                        <span class="sp-bt">成交金额</span>
                        <span class="sp-val">{{cjMap.dd.cj}}</span>
                        <span class="sp-val">{{cjMap.kd.cj}}</span>
                        <span class="sp-val2">{{cjMap.zj.cj}}</span>
                    </div>
                    <div class="tjnr-item">
                        <span class="sp-bt">微信支付</span>
                        <span class="sp-val">{{cjMap.dd.wx}}</span>
                        <span class="sp-val">{{cjMap.kd.wx}}</span>
                        <span class="sp-val2">{{cjMap.zj.wx}}</span>
                    </div>
                    <div class="tjnr-item">
                        <span class="sp-bt">金豆支付</span>
                        <span class="sp-val">{{cjMap.dd.jd}}</span>
                        <span class="sp-val">{{cjMap.kd.jd}}</span>
                        <span class="sp-val2">{{cjMap.zj.jd}}</span>
                    </div>
                </div>
            </div>
            <div class="yyfx-item1" style="background-color: #8F86DE;">
                <div class="yyfx-item-bt2" style="margin-left: 10px">
                    <span style="color: #ffffff">费/税率分析</span>
                </div>
                <div class="tj-nr" style="background-color: #FFFFFF">
                    <div class="tjnr-item3">
                        <span class="sp-bt">类别</span>
                        <span class="sp-val3">服务费</span>
                        <span class="sp-val3">所得税</span>
                        <span class="sp-val2">增值税</span>
                    </div>
                    <div class="tjnr-item2">
                        <span class="sp-bt">比例</span>
                        <span class="sp-val">{{fee.wxService}}%</span>
                        <span class="sp-val">{{fee.wxAdded}}%</span>
                        <span class="sp-val2">{{fee.wxPoints}}%</span>
                    </div>
                    <div class="tjnr-item2">
                        <span class="sp-bt">金额</span>
                        <span class="sp-val">{{fee.fwFee}}</span>
                        <span class="sp-val">{{fee.zzTax}}</span>
                        <span class="sp-val2">{{fee.qyTax}}</span>
                    </div>
                </div>
            </div>
            <div class="yyfx-item">
                <div class="yyfx-item-bt2">
                    <span><span style="font-size: 15px;font-weight: bold">顾客分析</span> ?</span>
                    <p style="color: #a2a2a2;margin-top: 8px;font-size: 11px">关注新老客户占比复购率,提升下单频率</p>
                </div>
               <div style="margin-top: 10px">
                   <div id="bing" style="width: 100%; height: 260px"></div>
               </div>
            </div>
            <div class="yyfx-item">
                <div class="yyfx-item-bt">
                    <span>应支付收益统计</span>
                </div>
                <div class="yyfx-nr1">
                    <div class="nr-item1">
                        <span>{{zc.zjxsCmn}}</span>
                        <span>直接销售提成</span>
                    </div>
                    <div class="nr-item1">
                        <span>{{zc.jjBonus}}</span>
                        <span>间接奖金</span>
                    </div>
                    <div class="nr-item1">
                        <span>{{zc.bmBonus}}</span>
                        <span>部门分润</span>
                    </div>
                    <div class="nr-item1">
                        <span>{{zc.pjBonus}}</span>
                        <span>平级奖金</span>
                    </div>
                    <div class="nr-item1">
                        <span>{{zc.blBonus}}</span>
                        <span>伯乐奖金</span>
                    </div>
                    <div class="nr-item1">
                        <span>{{zc.fh}}</span>
                        <span>分红</span>
                    </div>
                </div>
            </div>
            <div class="yyfx-item">
                <div class="yyfx-item-bt">
                    <span>分账统计</span>
                </div>
                <div class="yyfx-nr1">
                    <div class="nr-item1">
                        <span>自动分账</span>
                        <span>{{fztj.wxfz}}</span>
                    </div>
                    <div class="nr-item1">
                        <span>微信转账</span>
                        <span>{{fztj.wxzz}}</span>
                    </div>
                    <div class="nr-item1">
                        <span>支付宝转账</span>
                        <span>{{fztj.alizz}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";
    import Cxdate from "../../common/cxdate.vue";
    import * as echarts from 'echarts';
    export default {
        components: {Cxdate},
        data() {
            return {
                title: '运营分析',
                fwUser: {},
                deptId: '',
                token: '',
                userType: '',
                dateType: 0,
                staDate: '',
                endDate: '',
                cjMap: {
                    dd: {cj: 0, jd: 0, num: 0, wx: 0,},
                    kd: {cj: 0, jd: 0, num: 0, wx: 0,},
                    zj: {cj: 0, jd: 0, num: 0, wx: 0,},
                },
                yjs: {},
                zc: {
                    zjxsCmn: 0,
                    jjBonus: 0,
                    bmBonus: 0,
                    pjBonus: 0,
                    blBonus: 0,
                    fh: 0,
                },
                fztj: {
                    wxfz: 0,
                    wxzz: 0,
                    alizz: 0,
                },
                gailan: {
                    payPrice: 0,
                    fzAmount: 0,
                    fwFee: 0,
                },
                fee: {
                    wxPoints: 0,
                    wxService: 0,
                    wxAdded: 0,
                    fwFee: 0,
                    zzTax: 0,
                    qyTax: 0,
                },
                xdTotal:0,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            this.onLoad()
            // this.getBing();
        },
        methods: {
            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.onLoad()
                // this.getBing()
            },

            async onLoad() {
                let data = {
                    token: this.token,
                    dateType: this.dateType,
                    staDate: this.staDate,
                    endDate: this.endDate,
                }
                let res = await this.$get("/fw/getFwYyAnalysis", data)
                this.gailan = res.gailan
                this.cjMap = res.cjMap
                this.fee = res.fee
                this.zc = res.zc
                this.yjs = res.yjs
                this.fztj = res.fztj
                this.xdTotal = res.xdTotal
                    this.$nextTick(() => {
                        this.bingChart(res.bings)
                    })
            },

            // async getBing(){
            //     let data = {
            //         token: this.token,
            //         dateType: this.dateType,
            //         staDate: this.staDate,
            //         endDate: this.endDate,
            //     }
            //     let res = await this.$get("/fw/getFwYyAnalysis", data)

            //     this.$nextTick(() => {
            //         this.bingChart()
            //     })
            // },

            //饼图左
            bingChart(list) {
                let myChart = echarts.init(document.getElementById("bing"));
                let option = {
                    title: {
                        text: "总数",
                        subtext: this.xdTotal.toString(),
                        top: "40%",
                        left: "48.5%",
                        textAlign: "center",
                        fontSize: '20',
                    },
                    tooltip: {
                        show: false,
                    },
                    legend: {
                        orient: "vertical",
                        selectedMode: false,
                        left: 'left',
                        fontSize: 1,
                        data: list,
                        formatter: function (name) {
                            let num = "";
                            let zb = "";
                            list.forEach((item) => {
                                //格式化图例文本，支持字符串模板和回调函数两种形式。
                                if (item.name === name) {
                                    num = String(item.value).replace(/(\d)(?=(?:\d{6})+$)/g, "$1.");
                                    zb = item.zb;
                                    return;
                                }
                            });
                            return name + "：" + num+' '+zb;
                        },
                    },
                    series: [
                        {
                            name: "",
                            type: "pie",
                            radius: ["45%", "60%"],
                            avoidLabelOverlap: false,
                            silent: false, //图形是否不响应和触发鼠标事件，默认为 false，即响应和触发鼠标事件。
                            clickable: false, //取消图表上的点击事件
                            hoverAnimation: false,
                            zlevel: 1,
                            label: {
                                show: true,
                                position: "center",
                                normal: {
                                    position: "inner",
                                    show: false,
                                },
                            },
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: false,
                                    },
                                },
                            },
                            emphasis: {
                                show: false,
                                label: {
                                    show: false,
                                    fontSize: '20',
                                    fontWeight: "bold",
                                },
                            },
                            data: list,
                        },

                    ],
                };
                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            },

            onClickLeft() {
                this.$router.go(-1)
            },
        },
    }
    ;
</script>

<style lang="scss" scoped>
    .fw-yyfx {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        padding-bottom: 49px;
        background-color: #F3F2F7;
    }

    .yyfx {

    }

    .yyfx-item {
        margin: 10px;
        background-color: #FFFFFF;
        padding: 8px;
    }

    .yyfx-item1 {
        margin: 10px;
        background-color: #FFFFFF;
    }

    .tj-nr {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .tjnr-item {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .tjnr-item1 {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 5px 0 5px rgba(0, 0, 0, 0.1); /* 右侧阴影 */
    }

    .tjnr-item2 {
        width: 40%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .tjnr-item3 {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 5px 0 5px rgba(0, 0, 0, 0.1); /* 右侧阴影 */
    }

    .sp-bt {
        padding-top: 23px;
        font-size: 13px;
    }

    .sp-val {
        padding-top: 23px;
        font-size: 11px;
    }

    .sp-val2 {
        padding: 23px 0;
        font-size: 11px;
    }

    .sp-val1 {
        padding-top: 23px;
        font-size: 11px;
        color: #848282;
    }

    .sp-val3 {
        padding-top: 23px;
        font-size: 11px;
    }

    .yyfx-item-bt {
        border-bottom: #EEEEEE solid 1px;
        font-size: 13px;
        padding-top: 8px;
        padding-bottom: 7px;
    }

    .yyfx-item-bt1 {
        font-size: 13px;
        padding-top: 8px;
        padding-bottom: 7px;
    }

    .yyfx-item-bt span {
        border-left: #2b94ff solid 3px;
        padding-left: 5px;
    }

    .yyfx-item-bt1 span {
        border-left: #2b94ff solid 3px;
        padding-left: 5px;
    }

    .yyfx-item-bt2 {
        font-size: 13px;
        padding-top: 8px;
        padding-bottom: 7px;
    }

    .yyfx-nr {
        display: flex;
        flex-flow: row wrap;
        padding-top: 10px;
    }

    .nr-item {
        flex: 1;
        box-sizing: border-box;
        padding: 5px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        font-size: 11px;
        width: calc(100% / 4); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc(100% / 4);
        max-width: calc(100% / 4);

        &:nth-child(4n + 4) {
            margin-right: 0;
        }
    }

    .nr-item span {
        text-align: center;
        height: 28px;
        line-height: 28px;
    }

    .yyfx-nr1 {
        display: flex;
        flex-flow: row wrap;
        padding-top: 10px;
    }

    .nr-item1 {
        flex: 1;
        box-sizing: border-box;
        padding: 5px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        font-size: 11px;
        width: calc(100% / 3); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc(100% / 3);
        max-width: calc(100% / 3);

        &:nth-child(3n + 3) {
            margin-right: 0;
        }
    }

    .nr-item1 span {
        text-align: center;
        height: 28px;
        line-height: 28px;
    }

    .sjyj {
        display: block;
        background-color: #FFFFFF;
        margin: 0 9px;
        border-top: #EEEEEE solid 1px;
        font-size: 11px;
        height: 35px;
        line-height: 35px;
    }

    .sjyj .sj-name {
        display: inline-block;
        width: 70%;
        text-align: right;
    }

    .sjyj .sj-val {
        display: inline-block;
        width: 30%;
        text-align: left;
        padding-left: 10px;
    }

</style>